import React from "react";
import { useNavigate } from "react-router-dom";
import AboutImg1 from "../../assets/images/patient_1.png";
import AboutImg2 from "../../assets/images/patient_2.jpg";
import HappyIcon from "../../assets/icons/outline-peoples-two.svg";
import CheckIcon from "../../assets/icons/tick.svg";
import CustomButton from "../Form/CustomButton";


const AboutSection = () => {
  const navigate = useNavigate();

  const handleLearnMoreClick = () => {
    navigate("/about");
  };

  return (
    <section className="px-4 md:py-24 bg-white mb-[100px] lg:mb-0">
      <div className="max-w-screen-xl mx-auto flex flex-col-reverse md:flex-row items-center gap-12 ">
        {/* Left - Images */}
        <div className="flex-[1.2] relative grid grid-cols-2 lg:h-[600px] h-auto gap-0 ">
          <img
            src={AboutImg1}
            alt="Care 1"
            className="object-cover w-full lg:h-[430px] h-[215px] 
             rounded-l-xl"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />

          <img
            src={AboutImg2}
            alt="Care 2"
            className="object-cover w-full h-[297px] lg:h-full  
            rounded-r-xl rounded-bl-xl"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />

          {/* Card - Happy Patients */}
          <div className="absolute lg:bottom-20 bottom-4 left-[5%] sm:left-[20%] bg-white p-4 rounded-xl shadow-lg flex items-center gap-4  max-sm:scale-90 w-auto">
            <img
              src={HappyIcon}
              alt="Happy Patients"
              className="w-10 h-10 lg:w-20 lg:h-20"
            />
            <div>
              <p className="text-level-2 font-bold text-green text-xl sm:text-2xl">
                personalised
              </p>
              <p className="text-[12px] lg:text-[18px] xl:text-[20px] text-[var(--light-gray-color)]">
                care plans
              </p>
            </div>
          </div>
        </div>

        {/* Right - Text */}
        <div className="flex-[0.8]  flex flex-col justify-between font-poppins text-center lg:text-left">
          <div>
            <h4 className="text-[var(--primary-orange-color)] text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 uppercase">
              About Roselea
            </h4>

            <h2 className="text-[14px] lg:text-[22px] xl:text-[25px] font-semibold text-green mb-[30px] leading-snug">
              We Take Care of Your Loved Ones - Just Like You Would
            </h2>
            <p className="text-[var(--light-gray-color)] text-[12px] lg:text-[18px] xl:text-[20px]  lg:text-justify font-light mb-6">
              At Roselea, we believe care is more than a service, it’s a
              relationship built on trust, empathy, and respect.
            </p>

            <ul className="mb-12 space-y-8 ">
              {[
                "Tailored care plans to fit unique needs",
                "Friendly, trained professionals",
                "A warm, homelike atmosphere",
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <img
                    src={CheckIcon}
                    alt="Check"
                    className="w-5 h-5 lg:w-7 lg:h-7 xl:w-8 xl:h-8"
                  />
                  <span className="text-[var(--light-gray-color)] text-[12px] lg:text-[18px] xl:text-[20px]">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Bottom-centered button */}
          <div className="flex flex-col sm:flex-row justify-center items-center font-poppins">
            <CustomButton
              bgColor="bg-[var(--primary-orange-color)]"
              buttonText="Learn More"
              width="w-36"
              textColor="text-white"
              textWeight="font-semibold"
              className={
                "hover:bg-white hover:border-[var(--primary-orange-color)] hover:text-[var(--primary-orange-color)]"
              }
              onClick={handleLearnMoreClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
